import React from "react";
import ModuleBaseList from "./ModuleBaseList";

const ModuleList: React.FC<{}> = () => {
  return <ModuleBaseList variables={{ where: { ausbildungsArtId: { eq: 1 } } }} />;
};

export default ModuleList;
